import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { changeFilters } from 'actions/search';

import s from './styles';

const SearchItem = (props) => {
  const {
    className,
    titleStyle,
    subregionStyle,
    addressStyle,
    title,
    address,
    subregion,
    id,
    ids,
    isFilter,
    changeFilters
  } = props;

  return (
    isFilter ?
      <Link to={`/?subregion=${ids.join(',')}`} className={cx(className, s.SearchItem)}>
        <div
          className={cx(titleStyle, s.Title)}
          onClick={() => changeFilters({ subregion: ids })}
        >{title}</div>
      </Link>
      :
      <Link to={`/building/${id}`} className={cx(className, s.SearchItem)}>
        <div className={cx(titleStyle, s.Title)}>{title}</div>
        <div className={s.SubTitle}>
          {subregion && <div className={cx(subregionStyle, s.Subregion)}>{subregion}, </div>}
          <div className={cx(addressStyle, s.Address)}>{` ${address}`}</div>
        </div>
      </Link>
  );
};

export default connect(
  null,
  { changeFilters }
)(SearchItem);



// WEBPACK FOOTER //
// ./src/components/Header/Search/SearchItem/SearchItem.js